import * as React from "react";
import { Base } from "ui/Scripts/source/framework/base";
import { Translations } from "ui/Scripts/source/models/translations";
import { AttachmentList } from "../attachment/attachmentList";
import { ToolButton } from "ui/Scripts/source/components/framework/toolButton";
import { AttachmentSummaryList } from "../attachment/attachmentSummaryList";
import { IIdColorTitle } from "ui/Scripts/source/models/common/idColorTitle";
import { IFileAttachment } from "ui/Scripts/source/models/common/fileAttachment";
import { EventEditUrgencyClassStateText } from "ui/Scripts/source/components/event/eventEditUrgencyClassStateText";
import { IEventSettingSimple } from "ui/Scripts/source/models/eventSettings/eventSettingSimple";
import { FormRow } from "../framework/formRow";

//EventEditBasicInformationSummary
interface IEventEditBasicInformationSummaryProp {
    urgencyClasses: IIdColorTitle[];
    userCompanyIsReceivingCompany: boolean;
    sourceCompanyIsTargetCompany: boolean;
    urgencyClassIsEditable: boolean;
    eventSetting: IEventSettingSimple;
    createCompanyName: string;
    companyName: string;
    unitName: string;
    urgencyClassId: string;
    code: string;
    date: string;
    time: string;
    name: string;
    observer: string;
    observerAction: string;
    description: string;
    latitude: number;
    longitude: number;
    locationName: string;
    lateThreshold: number;
    attachments: IFileAttachment[];
    onDownloadAttachment: (id: string) => void;
    userIsCreator: boolean;
    userIsIsSystemAdmin: boolean;
    canSelectUnit: boolean;
    onSelectUnit: () => void;
    onSelectUrgencyClass: () => void;
    canShowCamera: boolean;
    onRemoveAttachment: (id: string) => void;
    onAddAttachments: (fileList: FileList) => void;
    onAddPhoto: () => void;
}

export class EventEditBasicInformationSummary extends React.Component<IEventEditBasicInformationSummaryProp, {}> {
    render() {
        const props = this.props;
        return (
            <div className="summarySection">
                {(!props.sourceCompanyIsTargetCompany && props.userCompanyIsReceivingCompany) &&
                    <FormRow
                        label={Translations.Sender}
                    >
                        <div>{props.createCompanyName}</div>
                    </FormRow>
                }
                {(!props.sourceCompanyIsTargetCompany && !props.userCompanyIsReceivingCompany) &&
                    <FormRow
                        label={Translations.Receiver}
                    >
                        <div>{props.companyName}</div>
                    </FormRow>
                }
                <FormRow
                    label={Translations.Unit}
                    changeButton={props.canSelectUnit
                        ? <ToolButton
                            tooltip={Translations.Change}
                            classes={"edit round mono smaller right"}
                            onClick={props.onSelectUnit}
                        />
                        : null
                    }
                >
                    <div>{props.unitName}</div>
                </FormRow>
                <FormRow
                    label={Translations.EventUrgencyClass}
                    changeButton={props.urgencyClassIsEditable
                        ? <ToolButton
                            tooltip={Translations.Change}
                            classes={"edit round mono smaller right"}
                            onClick={props.onSelectUrgencyClass}
                        />
                        : null
                    }
                >
                    <div><EventEditUrgencyClassStateText urgencyClass={props.urgencyClasses.find(i => i.id === props.urgencyClassId)} wide={true} /></div>
                </FormRow>
                <FormRow
                    label={Translations.Date}
                >
                    <div>{props.date + (!Base.isZeroTimeStr(props.time) ? " " + props.time : "")}</div>
                </FormRow>
                <FormRow
                    label={Translations.Title}
                >
                    <div>{props.name}</div>
                </FormRow>
                <FormRow
                    label={Translations.Description}
                >
                    <div className="preWrap">{props.description}</div>
                </FormRow>
                <FormRow
                    label={Translations.Observer}
                >
                    <div>{props.observer}</div>
                </FormRow>
                {!!props.eventSetting?.observerActionIsInUse() &&
                    <FormRow
                        label={Translations.ObserverAction}
                    >
                        <div className="preWrap">{props.observerAction}</div>
                    </FormRow>
                }
                {props.attachments.length > 0 && (props.userIsCreator || props.userIsIsSystemAdmin) &&
                    <div className="row">
                        <div className="col-12">
                            <AttachmentList
                                isReadOnly={false}
                                canShowCamera={props.canShowCamera}
                                lateThreshold={props.lateThreshold}
                                attachments={props.attachments}
                                onDownloadAttachment={props.onDownloadAttachment}
                                onRemoveAttachment={props.onRemoveAttachment}
                                onAddAttachments={props.onAddAttachments}
                                onAddPhoto={props.onAddPhoto} />
                        </div>
                    </div>}
                {props.attachments.length > 0 && !(props.userIsCreator || props.userIsIsSystemAdmin) &&
                    <div className="row">
                        <div className="col-12">
                            <label className="control-label">{Translations.Attachments}</label>
                            <AttachmentSummaryList
                                lateThreshold={props.lateThreshold}
                                attachments={props.attachments}
                                onDownloadAttachment={props.onDownloadAttachment} />
                        </div>
                    </div>
                }
                {!!props.eventSetting?.locationIsInUse() && !Base.isNullOrUndefined(props.latitude) && !Base.isNullOrUndefined(props.longitude) && !Base.isNullOrEmpty(props.locationName) &&
                    <FormRow
                        label={Translations.Location}
                    >
                        <div className="locationLink" onClick={() => { Base.openLocationInMaps(props.latitude, props.longitude); }}>{!Base.isNullOrEmpty(props.locationName) ? props.locationName : (props.latitude.toLocaleFixed(6) + ", " + props.longitude.toLocaleFixed(6))}</div>
                    </FormRow>
                }
            </div>
        );
    }
}
